import { loadAndSaveCampusesList, loadAndSavePractitionersList } from '../../reducer/commonActions';

export default {
  loadAndSaveCampusesList,
  loadAndSavePractitionersList
};